import React, { useEffect, useState } from "react";
import { Modal, Button, ListGroup, Form } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import LinearProgress from "@mui/material/LinearProgress";

const ShareModal = ({ show, onClose, articleId }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedType, setSelectedType] = useState("topline");
    const [downlineMembers, setDownlineMembers] = useState([]);
    const [toplineMembers, setToplineMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [members, setMembers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchAllMembers = async () => {
        try {
            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAllUserData",
                created_by: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (Array.isArray(output) && output.length > 0) {
                setMembers(output);
            }
        } catch (error) {
            console.error("Error fetching downline members:", error);
        }
    };

    const fetchToplineMembers = async () => {
        try {
            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAllToplineMembers",
                user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (Array.isArray(output) && output.length > 0) {
                setToplineMembers(output);
            }
        } catch (error) {
            console.error("Error fetching topline members:", error);
        }
    };

    useEffect(() => {
        if (show) {
            // fetchMembers();
            fetchToplineMembers();
            fetchAllMembers();
        }
    }, [show]);

    const handleTypeChange = (event) => {
        setSelectedType(event.target.value);
        setSelectedMembers([]); // Clear selected members when type changes
    };

    const handleSelectMember = (memberKey) => {
        setSelectedMembers((prev) => {
            if (prev.includes(memberKey)) {
                return prev.filter((key) => key !== memberKey); // Remove if already selected
            } else {
                return [...prev, memberKey]; // Add to selected members
            }
        });
    };

    // const handleShare = async () => {
    //     toast.dismiss();

    //     const link = `${BASE_URL}detail/${articleId}`;

    //     setIsSubmitting(true);

    //     try {
    //         for (const memberKey of selectedMembers) {
    //             const member = [...members].find((m) => m.pk_user_key === memberKey);
    //             if (member) {
    //                 const response = await axios.post(`${BASE_URL}API/apicall`, {
    //                     email: member.user_email, // Assuming `email` property exists
    //                     ac_link: link,
    //                     security_key: security_key,
    //                     mode: "shareArticle",
    //                     created_by: sessionStorage.getItem("pk_user_key"),
    //                 });

    //                 const output = response.data;

    //                 if (output !== 1) {
    //                     throw new Error(`Failed to share the article with ${member.first_name} ${member.last_name}.`);
    //                 }
    //             }
    //         }
    //         toast.success("Shared successfully!", {
    //             autoClose: 3000,
    //         });
    //     } catch (error) {
    //         toast.error("Oops! Something went wrong.", {
    //             autoClose: 3000,
    //         });
    //         console.error("Error sharing the article:", error);
    //     } finally {
    //         setIsSubmitting(false);
    //         setSelectedMembers([]);
    //         setSearchTerm("");
    //         onClose();
    //     }
    // };


    // const handleShare = async () => {
    //     toast.dismiss();
    //     const link = `${BASE_URL}detail/${articleId}`;
    //     const createdBy = sessionStorage.getItem("pk_user_key");
    //     setIsSubmitting(true);

    //     try {
    //         for (const memberKey of selectedMembers) {
    //             const member = [...members].find((m) => m.pk_user_key === memberKey);
    //             if (member) {

    //                 const emailResponse = await axios.post(`${BASE_URL}API/apicall`, {
    //                     email: member.user_email,
    //                     ac_link: link,
    //                     security_key,
    //                     mode: "shareArticle",
    //                     created_by: createdBy,
    //                 });

    //                 const emailOutput = emailResponse.data;
    //                 if (emailOutput !== 1) {
    //                     throw new Error(`Failed to send email to ${member.first_name} ${member.last_name}`);
    //                 }
    //                 if (member.phone) {
    //                     // Just ensure the phone starts with '+'
    //                     const formattedPhone = member.phone.startsWith("+")
    //                         ? member.phone
    //                         : `+${member.phone.replace(/\D/g, "")}`;

    //                     try {
    //                         await axios.post(`${BASE_URL}API/send_sms.php`, {
    //                             mode: "shareArticleInSms",
    //                             phone: formattedPhone,
    //                             ac_link: link,
    //                             user_name: `${member.first_name} ${member.last_name}`,
    //                         });
    //                     } catch (smsErr) {
    //                         console.warn(`SMS failed for ${formattedPhone}:`, smsErr.message);
    //                     }
    //                 }
    //             }
    //         }

    //         toast.success("Shared successfully via Email & SMS!", { autoClose: 3000 });
    //     } catch (error) {
    //         toast.error("Oops! Something went wrong.", { autoClose: 3000 });
    //         console.error("Error sharing the article:", error);
    //     } finally {
    //         setIsSubmitting(false);
    //         setSelectedMembers([]);
    //         setSearchTerm("");
    //         onClose();
    //     }
    // };

    const handleShare = async () => {
        toast.dismiss();
        const link = `${BASE_URL}detail/${articleId}`;
        const createdBy = sessionStorage.getItem("pk_user_key");
        setIsSubmitting(true);

        let emailSuccess = 0;
        let emailFail = 0;
        let smsSuccess = 0;
        let smsFail = 0;

        try {
            for (const memberKey of selectedMembers) {
                const member = [...members].find((m) => m.pk_user_key === memberKey);
                if (!member) continue;

                try {
                    const emailResponse = await axios.post(`${BASE_URL}API/apicall`, {
                        email: member.user_email,
                        ac_link: link,
                        security_key,
                        mode: "shareArticle",
                        created_by: createdBy,
                    });

                    const emailOutput = emailResponse.data;
                    if (emailOutput === 1) {
                        emailSuccess++;
                    } else {
                        emailFail++;
                    }
                } catch {
                    emailFail++;
                }

                if (member.phone) {
                    const formattedPhone = member.phone.startsWith("+")
                        ? member.phone
                        : `+${member.phone.replace(/\D/g, "")}`;

                    try {
                        const smsResponse = await axios.post(`${BASE_URL}API/send_sms.php`, {
                            mode: "shareArticleInSms",
                            phone: formattedPhone,
                            ac_link: link,
                            created_by: createdBy,
                            security_key,

                        });

                        if (smsResponse.data.status === "success") {
                            smsSuccess++;
                        } else {
                            smsFail++;
                        }
                    } catch {
                        smsFail++;
                    }
                }
            }


            if (emailSuccess > 0)
                toast.success(`${emailSuccess} email(s) shared successfully.`, { autoClose: 2500 });
            if (emailFail > 0)
                toast.error(`${emailFail} email(s) failed to send.`, { autoClose: 3000 });

            if (smsSuccess > 0)
                toast.success(`${smsSuccess} SMS shared successfully.`, { autoClose: 2500 });
            if (smsFail > 0)
                toast.error(`${smsFail} SMS failed to send.`, { autoClose: 3000 });

        } catch (error) {
            console.error("Error in share process:", error);
            toast.error("Unexpected error during sharing.", { autoClose: 3000 });
        } finally {
            setIsSubmitting(false);
            setSelectedMembers([]);
            setSearchTerm("");
            onClose();
        }
    };


    const membersToDisplay = selectedType === "topline" ? toplineMembers : members;

    // Filter members based on the search term
    const filteredMembers = membersToDisplay.filter((member) => `${member.first_name} ${member.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <>
            <ToastContainer position="top-center" />
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Share Article</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <h4 className="text-center">Select Members to Share With</h4>

                        {/* Radio buttons for selecting member type */}
                        <div className="text-center mb-3">
                            <label>
                                <input type="radio" value="topline" checked={selectedType === "topline"} onChange={handleTypeChange} />
                                <span className="ps-2">Topline Members</span>
                            </label>
                            <label className="ms-3">
                                <input type="radio" value="members" checked={selectedType === "members"} onChange={handleTypeChange} />
                                <span className="ps-2">All Users</span>
                            </label>
                        </div>

                        <Form.Control
                            type="text"
                            placeholder="Search members..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="mb-3"
                        />

                        <ListGroup className="align-items-start" style={{ height: "500px", overflow: "auto" }}>
                            {filteredMembers.map((member) => (
                                <ListGroup.Item key={member.pk_user_key}>
                                    <input
                                        id={"name" + member.pk_user_key}
                                        type="checkbox"
                                        className="form-check-input rounded-0 border-dark"
                                        checked={selectedMembers.includes(member.pk_user_key)}
                                        onChange={() => handleSelectMember(member.pk_user_key)}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={"name" + member.pk_user_key}
                                        role="button"
                                    >{`${member.first_name} ${member.last_name}`}</label>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                        <div className="mt-3 text-center">
                            <Button variant="outline-dark" onClick={onClose}>
                                Back
                            </Button>
                            <Button variant="dark" onClick={handleShare} className="ms-2" disabled={isSubmitting}>
                                Send
                                {isSubmitting && <LinearProgress />}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <style jsx>{``}</style>
            </Modal>
        </>
    );
};

export default ShareModal;
